import { Fragment, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import MainLayout from '../../../commons/layout/MainLayout/index';

import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import ROUTERS from '../../../commons/constans/router';
import InfiniteScroll from 'react-infinite-scroll-component';
import _styles from './_styles.scss';
import moment from 'moment';
import ListItemComponent from '../../../commons/components/List/ListItemComponent';
import SkeletonLoadingComponent from '../../../commons/components/SkeletonLoading';
import { useNotice } from '../../../commons/customHooks/Notification';
import API, { ROUTES } from '../../../commons/api/api';

type props = {
  // notices.list: any,
  // loading: Boolean,
  // params: Object,
  // fetchMoreDataPaginate: Function,
  // lastPage: Number,
  // currentPage: Number,
};



const NotificationPageComponent = ({ }: props) => {
  const navigate = useNavigate();
	const location = useLocation();

	const [params, setParams] = useState({
    page: 1,
  });
  const [loadingNotice, setLoadingNotice] = useState(false);
  
  const [notices, isProcessing, lastPage, currentPage, total] = useNotice(params);

	const fetchMoreDataPaginate = (data) => {
    setParams({...params, ...data});
  };

  useEffect(() => {
    if (performance.navigation.type == 1) {
      navigate(location.pathname, { replace: true });
    }
  }, [window.performance])

	useEffect(() => {
    if (location?.state?.type === 'notLoadPage') {
      setLoadingNotice(true)
      API.get(ROUTES.API_NOTIFICATION).then(res => {
        setLoadingNotice(false);
        if (res.status === 200) {
          if (res.data.data?.total !== total) {
            setParams({
              ...params,
              page: 1
            })
          }
        }
      }).catch(e => {
        setLoadingNotice(false);
        console.log(e, 'e');
      })
      window.scrollTo({ top: location?.state?.offsetTop, behavior: 'smooth' });
    }
	}, [location?.state?.offsetTop])

  const backMenuHome = () => {
    navigate(ROUTERS.HOME, {
      state: {
        menuStatus: true,
      },
    });
  };

  const openDetail = (e, id) => {
    let url = ROUTERS.NOTIFICATION_DETAIL;
    url = url.replace(':id', id);
    navigate(url, {
			state: {
        type: 'notLoadPage',
        offsetTop: e.target.offsetTop - 54
      }
		});
  };

	
  const fetchMoreData = () => {
    navigate(location.pathname, { replace: true });
		let paramPage = {
      ...params,
      page: params.page + 1,
    }
    if (params.page < lastPage) {
      fetchMoreDataPaginate(paramPage);
    }
  }

  const loadingDiv = (
    <div className="lists__item loading-content">
      <div className="lists__item__content w-100">
        <span className="w-100">
          <SkeletonLoadingComponent circle={false} width="25%" height="14px" />
        </span>
        <h3 className="w-100">
          <SkeletonLoadingComponent circle={false} width="100%" height="14px" />
        </h3>
      </div>
      <div className="lists__item__action"></div>
    </div>
  );

  return (
    <MainLayout pageID={'notification'} displayBottomNav={false}>
      <HeaderHs2
        title={'공지사항'}
        labelLeft={true}
        labelRight={false}
        handleLabelLeft={backMenuHome}
      />
      <div className="wrapper">
				{((isProcessing || loadingNotice) && lastPage <= 1) ? (
							loadingDiv
						) : !notices.list || notices.list.length <= 0 ? (
							<div className="container mt-5 pt-5">
								<div className="row pt-5">
									<div className="col-12">
										<p className="text-center p-0 m-0">해당하는 데이터가 없습니다</p>
									</div>
								</div>
							</div>
						) : (
							notices.list.length > 0 &&
							<InfiniteScroll
								dataLength={notices.list.length}
								next={fetchMoreData}
								hasMore={currentPage < lastPage ? true : false}
								loader={loadingDiv}
							>
								{
									notices.list.map((value, key) => (
										<Fragment key={key}>
											<ListItemComponent
												subTitle={moment(value.start_date).format('Y-MM-DD')}
												title={value.title}
												rightArrow={true}
												handleClick={(e) => openDetail(e, value.id)}
											/>
										</Fragment>
								))
								}
							</InfiniteScroll>
						)}
      </div>
    </MainLayout>
  );
};

export default NotificationPageComponent;
